import type { CommandData } from '../types'

export function toggle() {
  const message: CommandData = {
    isFromNetwatch: true,
    command: 'toggle',
  }
  window.postMessage(message)
}
